<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>图片上传</h1>
        <p>该接口不用加密，调用子商户进件后，调用该接口上传图片资料。</p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.cash.route.hangmuxitong.com/uploadfile</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://cash.yunfastpay.com/uploadfile</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div><router-link tag="a" :to="{path:'/interface/zysm'}">下载deom</router-link>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>AGM0104</td></tr>
          <tr><td>组织机构代码</td><td>orgCd</td><td>String（15）</td><td>是</td><td>行方提供给合作方的唯一标识</td></tr>
          <tr><td>商户编号</td><td>mchtCd</td><td>String(15)</td><td>是</td><td>商户入驻成功后，生成的行方全局唯一的商户编号</td></tr>
          <tr><td>图片</td><td>uploadFile</td><td>String（102400）</td><td>是</td><td>将图片数据base64后放在此域</td></tr>
          <tr><td>文件名称</td><td>fileName</td><td>String（100）</td><td>是</td><td></td></tr>
          <tr><td>图片类型</td><td>imgType</td><td>String（6）</td><td>是</td><td>png，jpg，xml等等</td></tr>
          <tr><td>图片业务类别</td><td>busType</td><td>String（4）</td><td>是</td><td>0000:其它资料
            0010：门头图，
            0011：收银台照，
            0012：门店出口图，
            0020：店内环境图，
            0030：物料进店图，
            0040：营业执照图，
            0041：税务登记，
            0042：组织机构代码照片，
            0043：负责人照片，
            0050：银行卡正面图，
            0051：银行卡背面图，
            0053：手持银行卡图，
            0055：开户许可证，
            0058：代理人手持银行卡图，
            0060：身份证正面图，
            0061：身份证反面图，
            0062：手持身份图，
            0063：手持结算卡身份证，
            0065：代理身份证正面图，
            0066：代理身份证反面图，
            0067：代理身手持份证，
            0068：结算人身份证正面图，
            0069：结算人身份证反面图，
            0070：商户协议1，
            0071：商户协议2，
            0072：商户协议3，
            0075：银行卡授权委托书，
            0076：调查审批表照片，
            0077：征信查询照片，
            0078：租借合同，
            0079：定位截图，
            0091：受益人1身份证正面,
            0092：受益人1身份证反面,
            0093：受益人2身份证正面,
            0094：受益人2身份证反面,
            0095：受益人3身份证正面,
            0096：受益人3身份证反面,
            0097：受益人4身份证正面,
            0098：受益人4身份证反面
          </td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000  失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <!-- <tr><td>商户编号</td><td>mchtCd</td><td>String（15）</td><td>是</td><td></td></tr> -->
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'Tpsc',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/zshbj', 'name': '子商户报件'},
        {'url': '/interface/xwzshbj', 'name': '小微子商户报件'},
        {'url': '/interface/tpsc', 'name': '图片上传'},
        {'url': '/interface/zshktcp', 'name': '子商户开通产品'},
        {'url': '/interface/zshcx', 'name': '子商户开通查询'},
        {'url': '/interface/zshfzxy', 'name': '子商户分账协议签署'},
        {'url': '/interface/zshpz', 'name': '子商户业务配置'},
        {'url': '/interface/zshhd', 'name': '子商户回调'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/Tpsc.vue